const ATTRIBUTE_NAME_LABELS = {
  en_name: "英文名",
};

export function formatAttributeDisplayName(name) {
  return ATTRIBUTE_NAME_LABELS[name] || name;
}
